import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-258acc3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chain-tag"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.chainId)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$checkI18n(`chainName.${_ctx.chainId}`)), 1))
    : _createCommentVNode("", true)
}